import client_core from "@/services/clients/client_core";

const CheckinService = {
    getCheckins(params) {
        return client_core.get('dashboard/v1/checkins/', { params })
    }
}

export default CheckinService